import { type FC } from "react";
import { UserDetailShowPageContents } from "@clientFrontend/features/scout/components/UserDetailShowPageContents";
import { useUserDetailContents } from "@clientFrontend/features/scout/hooks/useUserDetailContents";
import { wrapper } from "./styles.css";

type Props = {
  fetchUrl: string;
};

export const UserDetailShow: FC<Props> = ({ fetchUrl }) => {
  const formattedData = useUserDetailContents(fetchUrl);

  if (!formattedData) return null;

  return (
    <div className={wrapper}>
      <UserDetailShowPageContents {...formattedData} />
    </div>
  );
};
